import { createSlice } from '@reduxjs/toolkit'
import { logout } from './AuthSlice'

const initialState = {
  list: {
    receptionists: [],
    practitioners: [],
    departments: [],
  },
  invoiceJob: null,
  itemWiseSummaryJob: null,
  itemWiseDetailedJob: null,
  residentialReportJob: null,
  approvalReportJob: null,
  insuranceReportJob: null,
  policyReportJob: null,

  invoiceJobs: [],
  itemWiseSummaryJobs: [],
  itemWiseDetailedJobs: [],
  labRadiologySummaryJobs: [],
  labRadiologyItemWiseJobs: [],
  practitionerItemSummaryJobs: [],
  residentialReportJobs: [],
  approvalReportJobs: [],
  insuranceReportJobs: [],
  policyReportJobs: [],
  icdInactiveReportJobs: [],
  externalPharmacySalesJobs: [],
  internalPharmacySalesJobs: [],
  preClaimSubmissionJobs: [],
  vatReturnDetailJobs: [],
  nonSaudiZeroVatAuditJobs: [],
  patientAnalysisReportJobs: [],
  salesDateWiseReportJobs: [],
  refundReportJobs: [],
}

const AppSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setList: (state, action) => {
      const { key, value } = action.payload
      state.list = { ...state.list, [key]: value }
    },
    setInvoiceJob: (state, action) => { state.invoiceJob = action.payload },
    setItemWiseSummaryJob: (state, action) => { state.itemWiseSummaryJob = action.payload },
    setItemWiseDetailedJob: (state, action) => { state.itemWiseDetailedJob = action.payload },
    setResidentialReportJob: (state, action) => { state.residentialReportJob = action.payload },
    setApprovalReportJob: (state, action) => { state.approvalReportJob = action.payload },
    setInsuranceReportJob: (state, action) => { state.insuranceReportJob = action.payload },
    setPolicyReportJob: (state, action) => { state.policyReportJob = action.payload },

    addInvoiceJob: (state, action) => {
      if (!state.invoiceJobs) state.invoiceJobs = []
      state.invoiceJobs.push(action.payload)
    },
    updateInvoiceJob: (state, action) => {
      if (!state.invoiceJobs) state.invoiceJobs = []
      const index = state.invoiceJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.invoiceJobs[index] = { ...state.invoiceJobs[index], ...action.payload }
    },
    removeInvoiceJob: (state, action) => {
      if (!state.invoiceJobs) state.invoiceJobs = []
      state.invoiceJobs = state.invoiceJobs.filter(job => job.jobId !== action.payload)
    },

    addItemWiseSummaryJob: (state, action) => {
      if (!state.itemWiseSummaryJobs) state.itemWiseSummaryJobs = []
      state.itemWiseSummaryJobs.push(action.payload)
    },
    updateItemWiseSummaryJob: (state, action) => {
      if (!state.itemWiseSummaryJobs) state.itemWiseSummaryJobs = []
      const index = state.itemWiseSummaryJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.itemWiseSummaryJobs[index] = { ...state.itemWiseSummaryJobs[index], ...action.payload }
    },
    removeItemWiseSummaryJob: (state, action) => {
      if (!state.itemWiseSummaryJobs) state.itemWiseSummaryJobs = []
      state.itemWiseSummaryJobs = state.itemWiseSummaryJobs.filter(job => job.jobId !== action.payload)
    },

    addItemWiseDetailedJob: (state, action) => {
      if (!state.itemWiseDetailedJobs) state.itemWiseDetailedJobs = []
      state.itemWiseDetailedJobs.push(action.payload)
    },
    updateItemWiseDetailedJob: (state, action) => {
      if (!state.itemWiseDetailedJobs) state.itemWiseDetailedJobs = []
      const index = state.itemWiseDetailedJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.itemWiseDetailedJobs[index] = { ...state.itemWiseDetailedJobs[index], ...action.payload }
    },
    removeItemWiseDetailedJob: (state, action) => {
      if (!state.itemWiseDetailedJobs) state.itemWiseDetailedJobs = []
      state.itemWiseDetailedJobs = state.itemWiseDetailedJobs.filter(job => job.jobId !== action.payload)
    },

    addLabRadiologySummaryJob: (state, action) => {
      if (!state.labRadiologySummaryJobs) state.labRadiologySummaryJobs = []
      state.labRadiologySummaryJobs.push(action.payload)
    },
    updateLabRadiologySummaryJob: (state, action) => {
      if (!state.labRadiologySummaryJobs) state.labRadiologySummaryJobs = []
      const index = state.labRadiologySummaryJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.labRadiologySummaryJobs[index] = { ...state.labRadiologySummaryJobs[index], ...action.payload }
    },
    removeLabRadiologySummaryJob: (state, action) => {
      if (!state.labRadiologySummaryJobs) state.labRadiologySummaryJobs = []
      state.labRadiologySummaryJobs = state.labRadiologySummaryJobs.filter(job => job.jobId !== action.payload)
    },
    addLabRadiologyItemWiseJob: (state, action) => {
      if (!state.labRadiologyItemWiseJobs) state.labRadiologyItemWiseJobs = []
      state.labRadiologyItemWiseJobs.push(action.payload)
    },
    updateLabRadiologyItemWiseJob: (state, action) => {
      if (!state.labRadiologyItemWiseJobs) state.labRadiologyItemWiseJobs = []
      const index = state.labRadiologyItemWiseJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.labRadiologyItemWiseJobs[index] = { ...state.labRadiologyItemWiseJobs[index], ...action.payload }
    },
    removeLabRadiologyItemWiseJob: (state, action) => {
      if (!state.labRadiologyItemWiseJobs) state.labRadiologyItemWiseJobs = []
      state.labRadiologyItemWiseJobs = state.labRadiologyItemWiseJobs.filter(job => job.jobId !== action.payload)
    },

    addPractitionerItemSummaryJob: (state, action) => {
      if (!state.practitionerItemSummaryJobs) state.practitionerItemSummaryJobs = []
      state.practitionerItemSummaryJobs.push(action.payload)
    },
    updatePractitionerItemSummaryJob: (state, action) => {
      if (!state.practitionerItemSummaryJobs) state.practitionerItemSummaryJobs = []
      const index = state.practitionerItemSummaryJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.practitionerItemSummaryJobs[index] = { ...state.practitionerItemSummaryJobs[index], ...action.payload }
    },
    removePractitionerItemSummaryJob: (state, action) => {
      if (!state.practitionerItemSummaryJobs) state.practitionerItemSummaryJobs = []
      state.practitionerItemSummaryJobs = state.practitionerItemSummaryJobs.filter(job => job.jobId !== action.payload)
    },

    addResidentialReportJob: (state, action) => {
      if (!state.residentialReportJobs) state.residentialReportJobs = []
      state.residentialReportJobs.push(action.payload)
    },
    updateResidentialReportJob: (state, action) => {
      if (!state.residentialReportJobs) state.residentialReportJobs = []
      const index = state.residentialReportJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.residentialReportJobs[index] = { ...state.residentialReportJobs[index], ...action.payload }
    },
    removeResidentialReportJob: (state, action) => {
      if (!state.residentialReportJobs) state.residentialReportJobs = []
      state.residentialReportJobs = state.residentialReportJobs.filter(job => job.jobId !== action.payload)
    },

    addApprovalReportJob: (state, action) => {
      if (!state.approvalReportJobs) state.approvalReportJobs = []
      state.approvalReportJobs.push(action.payload)
    },
    updateApprovalReportJob: (state, action) => {
      if (!state.approvalReportJobs) state.approvalReportJobs = []
      const index = state.approvalReportJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.approvalReportJobs[index] = { ...state.approvalReportJobs[index], ...action.payload }
    },
    removeApprovalReportJob: (state, action) => {
      if (!state.approvalReportJobs) state.approvalReportJobs = []
      state.approvalReportJobs = state.approvalReportJobs.filter(job => job.jobId !== action.payload)
    },

    addInsuranceReportJob: (state, action) => {
      if (!state.insuranceReportJobs) state.insuranceReportJobs = []
      state.insuranceReportJobs.push(action.payload)
    },
    updateInsuranceReportJob: (state, action) => {
      if (!state.insuranceReportJobs) state.insuranceReportJobs = []
      const index = state.insuranceReportJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.insuranceReportJobs[index] = { ...state.insuranceReportJobs[index], ...action.payload }
    },
    removeInsuranceReportJob: (state, action) => {
      if (!state.insuranceReportJobs) state.insuranceReportJobs = []
      state.insuranceReportJobs = state.insuranceReportJobs.filter(job => job.jobId !== action.payload)
    },

    addPolicyReportJob: (state, action) => {
      if (!state.policyReportJobs) state.policyReportJobs = []
      state.policyReportJobs.push(action.payload)
    },
    updatePolicyReportJob: (state, action) => {
      if (!state.policyReportJobs) state.policyReportJobs = []
      const index = state.policyReportJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.policyReportJobs[index] = { ...state.policyReportJobs[index], ...action.payload }
    },
    removePolicyReportJob: (state, action) => {
      if (!state.policyReportJobs) state.policyReportJobs = []
      state.policyReportJobs = state.policyReportJobs.filter(job => job.jobId !== action.payload)
    },

    addIcdInactiveReportJob: (state, action) => {
      if (!state.icdInactiveReportJobs) state.icdInactiveReportJobs = []
      state.icdInactiveReportJobs.push(action.payload)
    },
    updateIcdInactiveReportJob: (state, action) => {
      if (!state.icdInactiveReportJobs) state.icdInactiveReportJobs = []
      const index = state.icdInactiveReportJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.icdInactiveReportJobs[index] = { ...state.icdInactiveReportJobs[index], ...action.payload }
    },
    removeIcdInactiveReportJob: (state, action) => {
      if (!state.icdInactiveReportJobs) state.icdInactiveReportJobs = []
      state.icdInactiveReportJobs = state.icdInactiveReportJobs.filter(job => job.jobId !== action.payload)
    },

    addExternalPharmacySalesJob: (state, action) => {
      if (!state.externalPharmacySalesJobs) state.externalPharmacySalesJobs = []
      state.externalPharmacySalesJobs.push(action.payload)
    },
    updateExternalPharmacySalesJob: (state, action) => {
      if (!state.externalPharmacySalesJobs) state.externalPharmacySalesJobs = []
      const index = state.externalPharmacySalesJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.externalPharmacySalesJobs[index] = { ...state.externalPharmacySalesJobs[index], ...action.payload }
    },
    removeExternalPharmacySalesJob: (state, action) => {
      if (!state.externalPharmacySalesJobs) state.externalPharmacySalesJobs = []
      state.externalPharmacySalesJobs = state.externalPharmacySalesJobs.filter(job => job.jobId !== action.payload)
    },

    addInternalPharmacySalesJob: (state, action) => {
      if (!state.internalPharmacySalesJobs) state.internalPharmacySalesJobs = []
      state.internalPharmacySalesJobs.push(action.payload)
    },
    updateInternalPharmacySalesJob: (state, action) => {
      if (!state.internalPharmacySalesJobs) state.internalPharmacySalesJobs = []
      const index = state.internalPharmacySalesJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.internalPharmacySalesJobs[index] = { ...state.internalPharmacySalesJobs[index], ...action.payload }
    },
    removeInternalPharmacySalesJob: (state, action) => {
      if (!state.internalPharmacySalesJobs) state.internalPharmacySalesJobs = []
      state.internalPharmacySalesJobs = state.internalPharmacySalesJobs.filter(job => job.jobId !== action.payload)
    },

    addPreClaimSubmissionJob: (state, action) => {
      if (!state.preClaimSubmissionJobs) state.preClaimSubmissionJobs = []
      state.preClaimSubmissionJobs.push(action.payload)
    },
    updatePreClaimSubmissionJob: (state, action) => {
      if (!state.preClaimSubmissionJobs) state.preClaimSubmissionJobs = []
      const index = state.preClaimSubmissionJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.preClaimSubmissionJobs[index] = { ...state.preClaimSubmissionJobs[index], ...action.payload }
    },
    removePreClaimSubmissionJob: (state, action) => {
      if (!state.preClaimSubmissionJobs) state.preClaimSubmissionJobs = []
      state.preClaimSubmissionJobs = state.preClaimSubmissionJobs.filter(job => job.jobId !== action.payload)
    },

    addVatReturnDetailJob: (state, action) => {
      if (!state.vatReturnDetailJobs) state.vatReturnDetailJobs = []
      state.vatReturnDetailJobs.push(action.payload)
    },
    updateVatReturnDetailJob: (state, action) => {
      if (!state.vatReturnDetailJobs) state.vatReturnDetailJobs = []
      const index = state.vatReturnDetailJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.vatReturnDetailJobs[index] = { ...state.vatReturnDetailJobs[index], ...action.payload }
    },
    removeVatReturnDetailJob: (state, action) => {
      if (!state.vatReturnDetailJobs) state.vatReturnDetailJobs = []
      state.vatReturnDetailJobs = state.vatReturnDetailJobs.filter(job => job.jobId !== action.payload)
    },

    addNonSaudiZeroVatAuditJob: (state, action) => {
      if (!state.nonSaudiZeroVatAuditJobs) state.nonSaudiZeroVatAuditJobs = []
      state.nonSaudiZeroVatAuditJobs.push(action.payload)
    },
    updateNonSaudiZeroVatAuditJob: (state, action) => {
      if (!state.nonSaudiZeroVatAuditJobs) state.nonSaudiZeroVatAuditJobs = []
      const index = state.nonSaudiZeroVatAuditJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.nonSaudiZeroVatAuditJobs[index] = { ...state.nonSaudiZeroVatAuditJobs[index], ...action.payload }
    },
    removeNonSaudiZeroVatAuditJob: (state, action) => {
      if (!state.nonSaudiZeroVatAuditJobs) state.nonSaudiZeroVatAuditJobs = []
      state.nonSaudiZeroVatAuditJobs = state.nonSaudiZeroVatAuditJobs.filter(job => job.jobId !== action.payload)
    },

    addPatientAnalysisReportJob: (state, action) => {
      if (!state.patientAnalysisReportJobs) state.patientAnalysisReportJobs = []
      state.patientAnalysisReportJobs.push(action.payload)
    },
    updatePatientAnalysisReportJob: (state, action) => {
      if (!state.patientAnalysisReportJobs) state.patientAnalysisReportJobs = []
      const index = state.patientAnalysisReportJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.patientAnalysisReportJobs[index] = { ...state.patientAnalysisReportJobs[index], ...action.payload }
    },
    removePatientAnalysisReportJob: (state, action) => {
      if (!state.patientAnalysisReportJobs) state.patientAnalysisReportJobs = []
      state.patientAnalysisReportJobs = state.patientAnalysisReportJobs.filter(job => job.jobId !== action.payload)
    },

    addSalesDateWiseReportJob: (state, action) => {
      if (!state.salesDateWiseReportJobs) state.salesDateWiseReportJobs = []
      state.salesDateWiseReportJobs.push(action.payload)
    },
    updateSalesDateWiseReportJob: (state, action) => {
      if (!state.salesDateWiseReportJobs) state.salesDateWiseReportJobs = []
      const index = state.salesDateWiseReportJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.salesDateWiseReportJobs[index] = { ...state.salesDateWiseReportJobs[index], ...action.payload }
    },
    removeSalesDateWiseReportJob: (state, action) => {
      if (!state.salesDateWiseReportJobs) state.salesDateWiseReportJobs = []
      state.salesDateWiseReportJobs = state.salesDateWiseReportJobs.filter(job => job.jobId !== action.payload)
    },

    addRefundReportJob: (state, action) => {
      if (!state.refundReportJobs) state.refundReportJobs = []
      state.refundReportJobs.push(action.payload)
    },
    updateRefundReportJob: (state, action) => {
      if (!state.refundReportJobs) state.refundReportJobs = []
      const index = state.refundReportJobs.findIndex(job => job.jobId === action.payload.jobId)
      if (index !== -1) state.refundReportJobs[index] = { ...state.refundReportJobs[index], ...action.payload }
    },
    removeRefundReportJob: (state, action) => {
      if (!state.refundReportJobs) state.refundReportJobs = []
      state.refundReportJobs = state.refundReportJobs.filter(job => job.jobId !== action.payload)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state.invoiceJob = null
      state.itemWiseSummaryJob = null
      state.itemWiseDetailedJob = null
      state.residentialReportJob = null
      state.approvalReportJob = null
      state.insuranceReportJob = null
      state.policyReportJob = null
      state.invoiceJobs = []
      state.itemWiseSummaryJobs = []
      state.itemWiseDetailedJobs = []
      state.labRadiologySummaryJobs = []
      state.doctorWiseRevenueJobs = []
      state.practitionerItemSummaryJobs = []
      state.residentialReportJobs = []
      state.approvalReportJobs = []
      state.insuranceReportJobs = []
      state.policyReportJobs = []
      state.icdInactiveReportJobs = []
      state.externalPharmacySalesJobs = []
      state.internalPharmacySalesJobs = []
      state.preClaimSubmissionJobs = []
      state.vatReturnDetailJobs = []
      state.nonSaudiZeroVatAuditJobs = []
      state.patientAnalysisReportJobs = []
      state.salesDateWiseReportJobs = []
      state.refundReportJobs = []
    })
  },
})

export const {
  setList,
  setInvoiceJob, setItemWiseSummaryJob, setItemWiseDetailedJob,
  setResidentialReportJob, setApprovalReportJob, setInsuranceReportJob, setPolicyReportJob,
  addInvoiceJob, updateInvoiceJob, removeInvoiceJob,
  addItemWiseSummaryJob, updateItemWiseSummaryJob, removeItemWiseSummaryJob,
  addItemWiseDetailedJob, updateItemWiseDetailedJob, removeItemWiseDetailedJob,
  addLabRadiologySummaryJob, updateLabRadiologySummaryJob, removeLabRadiologySummaryJob,
  addLabRadiologyItemWiseJob, updateLabRadiologyItemWiseJob, removeLabRadiologyItemWiseJob,
  addPractitionerItemSummaryJob, updatePractitionerItemSummaryJob, removePractitionerItemSummaryJob,
  addResidentialReportJob, updateResidentialReportJob, removeResidentialReportJob,
  addApprovalReportJob, updateApprovalReportJob, removeApprovalReportJob,
  addInsuranceReportJob, updateInsuranceReportJob, removeInsuranceReportJob,
  addPolicyReportJob, updatePolicyReportJob, removePolicyReportJob,
  addIcdInactiveReportJob, updateIcdInactiveReportJob, removeIcdInactiveReportJob,
  addExternalPharmacySalesJob, updateExternalPharmacySalesJob, removeExternalPharmacySalesJob,
  addInternalPharmacySalesJob, updateInternalPharmacySalesJob, removeInternalPharmacySalesJob,
  addPreClaimSubmissionJob, updatePreClaimSubmissionJob, removePreClaimSubmissionJob,
  addVatReturnDetailJob, updateVatReturnDetailJob, removeVatReturnDetailJob,
  addNonSaudiZeroVatAuditJob, updateNonSaudiZeroVatAuditJob, removeNonSaudiZeroVatAuditJob,
  addPatientAnalysisReportJob, updatePatientAnalysisReportJob, removePatientAnalysisReportJob,
  addSalesDateWiseReportJob, updateSalesDateWiseReportJob, removeSalesDateWiseReportJob,
  addRefundReportJob, updateRefundReportJob, removeRefundReportJob,
} = AppSlice.actions

export default AppSlice.reducer
